import { Badge } from '@/components/ui';
import { getFixtureVesselSizeInfo } from '@/utils/fixtureUtils';

interface FixtureVesselSizeBadgeProps {
  /** TIXFixtures vessel size id: 2 = VLCC, 3 = Suezmax */
  vesselSizeId: number | null | undefined;
}

/**
 * Small VLCC / Suezmax badge derived from a Recent Fixture's vesselSizeId.
 * Renders nothing for unknown / missing sizes.
 */
export function FixtureVesselSizeBadge({ vesselSizeId }: FixtureVesselSizeBadgeProps) {
  const info = getFixtureVesselSizeInfo(vesselSizeId);
  if (!info) return null;
  return (
    <Badge size="sm" variant={info.variant}>
      {info.label}
    </Badge>
  );
}
